export default "__VITE_ASSET__BkLmDshJ__"